import { h } from 'preact'

interface ValueDescriptionsMap {
  [key: number]: string;
}

interface Props {
  options: Array<any>,
  onChange: (option: string, idx: number) => void,
  value: string | JSX.Element,
  title?: string,
  valueDescriptions?: ValueDescriptionsMap,
  meta?: string,
  name?: string,
  required?: boolean,
  disabled?: boolean,
  underneath?: boolean
}
const RadioInputGroup = (props: Props) => {
  const input = props.options
    .map((option, idx) => <label className={`radio-inline${props.underneath ? ' radio-inline--underneath' : ''}`}>
      <input type={'radio'}
        name={props.name}
        className={`qa-${option}`}
        required={props.required}
        disabled={props.disabled}
        onChange={() => props.onChange(option, idx)}
        checked={option === props.value} />
      {option}
      {props.valueDescriptions && <p className='radio-value-description'>{props.valueDescriptions[idx]}</p>}
    </label>)
    .reduce((prev: Array<any>, curr) => prev.concat([' ', curr]), [])

  return <div className={`form-group ${props.title ? 'qa-' + props.title.split(' ').join('') : ''}`}>
    {
      props.title ? <label>{props.title}</label> : null
    }
    {
      props.meta ? props.meta : null
    }
    <div className={'radio-group'}>
      {input}
    </div>
  </div>
}

export default RadioInputGroup
